import moment from 'moment';
import React, { Component } from 'react';
import {
  Alert,
  Button,
  Grid,
  Row,
  Table,
  ToggleButton,
  ToggleButtonGroup,
} from 'react-bootstrap';
import DatePicker from 'react-date-picker';
import Select from 'react-select';
import LoaderButton from '../components/LoaderButton';
import RouteStop from '../components/PackingSlips/RouteStop';
import PalletSlip from '../components/PackingSlips/PalletSlip';
import { comparePalletsForDisplay } from '../components/PalletOperations/palletUtils';
import { PrintGridContainer } from '../components/PackingSlips/AldiPackingSlip';
import { US_STATES, US_STATES_CUSTOM_CODES } from '../constants/USStates';
import {
  GetOpsLocations,
  Items,
  LocationIDs,
  PackingSlipPreview,
  PaginatedPackingSlip,
  GetFulfillmentPriority,
  ItemsWithFoodInfo,
  GetPallets,
  GetJarSize,
  OrderMeta,
} from '../libs/GraphQL';
import { aggregateColdChainPreviewSlips } from '../utils/coldChainPreview';
import { yyyymmdd } from '../libs/date_convert';
import { generateLayout } from '../libs/generateLayout';
import Loading from '../atoms/Loading';
import { mockOpsLocations, mockItems, mockLocations } from '../utils/SLIP_DATA';
import { returnedSlips } from '../utils/SLIP_RESPONSE';
import bugImage from '../atoms/icons/usda_bug.png';

const ITEMS_WITH_FOOD_INFO = [
  {
    id: 'BERRY_GRANOLA_YOGURT',
    itemNumber: '201355',
    netWeight: {
      oz: 6.87,
      g: 195,
    },
  },
  {
    id: 'PINEAPPLE_CHIA_BIG',
    itemNumber: '201394',
    netWeight: {
      oz: 7.81,
      g: 221,
    },
  },
  {
    id: 'PESTO_PASTA_BOWL',
    itemNumber: '201412',
    netWeight: {
      oz: 8.31,
      g: 236,
    },
  },
  {
    id: 'TURKEY_SANDWICH',
    itemNumber: '501438',
    netWeight: {
      oz: 7.61,
      g: 216,
    },
  },
  {
    id: 'USDA_BAJA_CHIC_WRAP',
    itemNumber: '501406',
    netWeight: {
      oz: 8.49,
      g: 241,
    },
    usdaBugImage: bugImage,
  },
  {
    id: 'SONOMA_SALAD',
    itemNumber: '306416',
    netWeight: {
      oz: 11.09,
      g: 314,
    },
  },
  {
    id: 'BAJA_BOWL',
    itemNumber: '201488',
    netWeight: {
      oz: 9.52,
      g: 270,
    },
  },
  {
    id: 'TURKEY_SANDWICH_RETAIL',
    itemNumber: '501438',
    netWeight: {
      oz: 7.61,
      g: 216,
    },
  },
  {
    id: 'USDA_VALUE_CSR_CHIC',
    itemNumber: '306418',
    netWeight: {
      oz: 7.76,
      g: 219,
    },
    usdaBugImage: bugImage,
  },
  {
    id: 'MEDI_BOWL',
    itemNumber: '201490',
    netWeight: {
      oz: 9.15,
      g: 259,
    },
  },
  {
    id: 'USDA_PESTO_CHICKEN_SALAD_WRAP',
    itemNumber: '501441',
    netWeight: {
      oz: 8.5,
      g: 241,
    },
    usdaBugImage: bugImage,
  },
  {
    id: 'USDA_PESTO_CHIX_WRAP_052026',
    itemNumber: '501441',
    netWeight: {
      oz: 8.5,
      g: 241,
    },
    usdaBugImage: bugImage,
  },
  {
    id: 'CRUNCHY_THAI_BOWL',
    itemNumber: '306417',
    netWeight: {
      oz: 7.77,
      g: 220,
    },
  },
  {
    id: 'SAUSAGE_BURRITO_BREAKFAST',
    itemNumber: '306443',
    netWeight: {
      oz: 6.97,
      g: 198,
    },
  },
  // Home Delivery (Cold Chain) menu — the SKUs sold for home delivery come
  // from the DeliveryMenu table; item numbers and net weights from the
  // Menu Library (Full Menu Summary sheet)
  {
    id: 'BAJA_BOWL_042026',
    itemNumber: '201488',
    netWeight: {
      oz: 8.21,
      g: 233,
    },
  },
  {
    id: 'BLUEBERRY_CHIA_OATS',
    itemNumber: '201572',
    netWeight: {
      oz: 8.91,
      g: 253,
    },
  },
  {
    id: 'CHICKEN_CAESAR_SALAD',
    itemNumber: '302405',
    netWeight: {
      oz: 9.11,
      g: 258,
    },
  },
  {
    id: 'CHIMICHURRI_STEAK_BOWL_202601',
    itemNumber: '306441',
    netWeight: {
      oz: 17.19,
      g: 487,
    },
  },
  {
    id: 'CLASSIC_CHIX_SALAD_BOWL',
    itemNumber: '306452',
    netWeight: {
      oz: 6.53,
      g: 185,
    },
  },
  {
    id: 'ELOTE_SALAD_202201',
    itemNumber: '302406',
    netWeight: {
      oz: 11.23,
      g: 318,
    },
  },
  {
    id: 'FUJI_APPLE_PECAN_SALAD',
    itemNumber: '371117',
    netWeight: {
      oz: 12.06,
      g: 342,
    },
  },
  {
    id: 'GREEK_SALAD_202510',
    itemNumber: '301385',
    netWeight: {
      oz: 11.31,
      g: 321,
    },
  },
  {
    id: 'GREEN_GODDESS_SALAD',
    itemNumber: '301510',
    netWeight: {
      oz: 12.4,
      g: 352,
    },
  },
  {
    id: 'HARVEST_CHICKEN_SALAD',
    itemNumber: '371070',
    netWeight: {
      oz: 12.94,
      g: 367,
    },
  },
  {
    id: 'HUEVOS_RANCHEROS_BOWL',
    itemNumber: '306457',
    netWeight: {
      oz: 8.65,
      g: 245,
    },
  },
  {
    id: 'PESTO_CHIX_PROTEIN_BOWL_PARM',
    itemNumber: '306432',
    netWeight: {
      oz: 14.7,
      g: 416,
    },
  },
  {
    id: 'PROTEIN_CHIX_COBB_SALAD',
    itemNumber: '306430',
    netWeight: {
      oz: 13.4,
      g: 380,
    },
  },
  {
    id: 'SOUTHWEST_CHIX_SALAD',
    itemNumber: '301421',
    netWeight: {
      oz: 11.39,
      g: 323,
    },
  },
  {
    id: 'STRAWBERRY_CREAM_CHIA',
    itemNumber: '371087',
    netWeight: {
      oz: 7.61,
      g: 216,
    },
  },
  {
    id: 'TACO_CHIX_PROTEIN_BOWL',
    itemNumber: '306434',
    netWeight: {
      oz: 14.18,
      g: 402,
    },
  },
  {
    id: 'VEG_CHICKPEA_SHAWARMA_PROTEIN_BOWL',
    itemNumber: '371131',
    netWeight: {
      oz: 15.98,
      g: 453,
    },
  },
];

const arrayToObject = (array, keyField) =>
  array.reduce((obj, item) => {
    obj[item[keyField]] = item;
    return obj;
  }, {});

// The preview endpoint returns { pallet, packingSlips } groups (slips
// without a pallet come in a { pallet: null } group); the Cold Chain
// aggregation needs a flat slip array.
const flattenPreviewSlips = (previewData) =>
  (previewData || []).flatMap((group) => group.packingSlips || []);

async function fetchOrdersById(date) {
  const ordersById = {};
  let nextToken = null;
  try {
    do {
      // paginated query — pages must be fetched sequentially
      // eslint-disable-next-line no-await-in-loop
      const response = await OrderMeta(nextToken, date);
      const page = response?.data?.ordersByDay;
      (page?.orders || []).forEach((order) => {
        ordersById[order.uniqueId] = order;
      });
      nextToken = page?.nextToken;
    } while (nextToken);
  } catch (error) {
    console.error('Error fetching orders for the Cold Chain preview:', error);
  }
  return ordersById;
}

// Retailer location patterns configuration
// To add a new retailer: NEW_RETAILER: ['IL_NEW_RETAILER_LOCATION_PATTERN']
const RETAILER_LOCATION_PATTERNS = {
  HMS: ['IL_HMS_OHARE__1000_BALMORAL_AVE'],
  DELTA: [
    'CA_LA_DELTA_INFLIGHT_LAX__6701_W_IMPERIAL_HWY',
    'GA_DELTA_CHARTERS_ATL__ 2200_MH_JACKSON_SERVICE',
    'CA_SD_DELTA_CHARTERS_SAN__3870_HOUSTON_STREET',
  ],
  ALDI: ['_ALDI_'],
  AVI: ['OH_AVI_RETAIL__2588_ELM_ROAD'],
  COLD_CHAIN: ['IL_3PL_COLD_CHAIN__199_SHEPARD_AVE'],
};

// Mapping from location patterns to actual retailer names in the database
const RETAILER_PATTERN_TO_NAME = {
  HMS: 'HMS Host',
  DELTA: 'Delta Airlines',
  ALDI: 'ALDI',
  AVI: 'AVI',
  COLD_CHAIN: 'Cold Chain',
};

// Mapping from retailer patterns to their corresponding opportunity names
// Use an array for retailers with multiple opportunity names (e.g., Delta)
const RETAILER_PATTERN_TO_OPPORTUNITY_NAME = {
  HMS: 'HMS Ohare',
  DELTA: ['Delta Inflight LAX', 'Delta Charters SAN', 'Delta Charters ATL'],
  AVI: 'AVI Retail',
  COLD_CHAIN: 'Cold Chain',
};

export default class ViewProdReport extends Component {
  constructor(props) {
    super(props);
    this.file = null;
    this.state = {
      previewSlips:
        window.location.pathname.split('/').slice(-1)[0] === 'preview',
      title:
        window.location.pathname.split('/').slice(-1)[0] === 'preview'
          ? 'Preview'
          : 'Allocation',
      isInitLoading: true,
      isLoading: false,
      showPicker: true,
      reportData: {},
      palletData: {},
      items: {},
      fridgeLocationIds: [],
      fridgeLocationState: {},
      currentDate: new Date(),
      searchDate: yyyymmdd(new Date(), '-'),
      packingSlipType: 'all',
      packingSlipPreviewType: 'all-orders',
      packingSlipGroup: 'all-groups',
      alertModal: {
        mode: false,
        text: '',
      },
      isACostcoStore: {},
      containerTypes: {},
      opsLocations: {},
      linehaulList: [],
      linehaulFilter: [],
      linehaulFilterType: 'all',
      retailerOptions: Object.keys(RETAILER_LOCATION_PATTERNS).map(
        (retailer) => ({
          value: retailer,
          label: RETAILER_PATTERN_TO_NAME[retailer] || retailer,
        }),
      ),
      itemsWithFoodInfo: [],
      retailerFilteredOpsLocations: {},
      toteSizes: {},
    };
    this.refreshData = this.refreshData.bind(this);
    this.handleDateChangeV2 = this.handleDateChangeV2.bind(this);
    this.showDatePicker = this.showDatePicker.bind(this);
    this.getForecastData = this.getForecastData.bind(this);
    this.downloadPackingSlips = this.downloadPackingSlips.bind(this);
    this.getFridgeLocationIds = this.getFridgeLocationIds.bind(this);
    this.getFridgeLocationState = this.getFridgeLocationState.bind(this);
    this.getFridgeRegion = this.getFridgeRegion.bind(this);
    this.getOrderRegion = this.getOrderRegion.bind(this);
    this.sundryCount = this.sundryCount.bind(this);
    this.shouldDisplaySundry = this.shouldDisplaySundry.bind(this);
    this.fetchAllPackingSlips = this.fetchAllPackingSlips.bind(this);
    this.handleLinehaulFilterChange =
      this.handleLinehaulFilterChange.bind(this);
    this.fetchItemsWithFoodInfo = this.fetchItemsWithFoodInfo.bind(this);
    this.filterRetailerOpsLocations =
      this.filterRetailerOpsLocations.bind(this);
  }

  filterRetailerOpsLocations(retailerName) {
    try {
      const actualRetailerName = RETAILER_PATTERN_TO_NAME[retailerName];
      if (!actualRetailerName) {
        console.error(
          `No retailer name mapping found for pattern: ${retailerName}`,
        );
        this.setState({
          retailerFilteredOpsLocations: {},
        });
        return {};
      }

      const allOpsLocations = Object.values(this.state.opsLocations);
      const filteredLocations = allOpsLocations.filter((location) => {
        const matchesRetailer = location.retailer === actualRetailerName;

        const expectedOpportunityNames =
          RETAILER_PATTERN_TO_OPPORTUNITY_NAME[retailerName];
        const matchesOpportunityName =
          expectedOpportunityNames &&
          (Array.isArray(expectedOpportunityNames)
            ? expectedOpportunityNames.includes(location.opportunityName)
            : location.opportunityName === expectedOpportunityNames);

        // Include location if it matches either retailer field or opportunityName
        return matchesRetailer || matchesOpportunityName;
      });

      const filteredLocationsMap = arrayToObject(filteredLocations, 'id');

      this.setState({
        retailerFilteredOpsLocations: filteredLocationsMap,
      });
      return filteredLocationsMap;
    } catch (error) {
      console.error('Error filtering retailer opsLocations:', error);
      this.setState({
        retailerFilteredOpsLocations: {},
      });
      return {};
    }
  }

  async fetchItemsWithFoodInfo() {
    try {
      const itemsWithFoodInfo = await Promise.all(
        ITEMS_WITH_FOOD_INFO.map(async (item) => {
          const response = await ItemsWithFoodInfo({
            id: item.id,
          });

          if (response?.data?.itemsV2?.[0]) {
            const foodInfo = response.data.itemsV2[0];
            return {
              ...item,
              prettyName: foodInfo.prettyName,
              foodInfo: foodInfo.foodInfo,
            };
          }
          return item;
        }),
      );

      // Store in localStorage
      localStorage.setItem(
        'itemsWithFoodInfo',
        JSON.stringify({
          items: itemsWithFoodInfo,
          date: moment().format('YYYY-MM-DD'),
        }),
      );

      return itemsWithFoodInfo;
    } catch (error) {
      console.error('Error fetching items with food info:', error);
      return ITEMS_WITH_FOOD_INFO;
    }
  }

  refreshData() {
    this.setState({ isLoading: true });
    this.getForecastData();
  }

  async componentDidMount() {
    try {
      const itemsAndLocationsCache = JSON.parse(
        localStorage.getItem('itemsAndLocationsCache'),
      );
      const itemsWithFoodInfoCache = JSON.parse(
        localStorage.getItem('itemsWithFoodInfo'),
      );

      if (
        itemsAndLocationsCache &&
        itemsAndLocationsCache.date &&
        moment(itemsAndLocationsCache.date).isSame(moment(), 'day') &&
        itemsAndLocationsCache.toteSizes &&
        itemsWithFoodInfoCache &&
        itemsWithFoodInfoCache.date &&
        moment(itemsWithFoodInfoCache.date).isSame(moment(), 'day')
      ) {
        this.setState({
          items: itemsAndLocationsCache.items,
          opsLocations: itemsAndLocationsCache.opsLocations,
          isACostcoStore: itemsAndLocationsCache.isACostcoStore,
          containerTypes: itemsAndLocationsCache.containerTypes,
          fridgeLocationIds: itemsAndLocationsCache.fridgeLocationIds,
          fridgeLocationState: itemsAndLocationsCache.fridgeLocationState,
          linehaulList: itemsAndLocationsCache.linehaulList,
          toteSizes: itemsAndLocationsCache.toteSizes,
          itemsWithFoodInfo: itemsWithFoodInfoCache.items,
          isInitLoading: false,
        });
      } else {
        // Initiate all requests simultaneously
        const [
          itemsResponse,
          allLocationsResponse,
          opsLocationsResponse,
          itemsWithFoodInfo,
          jarSizeResponse,
        ] = await Promise.all([
          Items(),
          LocationIDs(),
          GetOpsLocations({ status: ['LIVE'] }),
          this.fetchItemsWithFoodInfo(),
          GetJarSize().catch((error) => {
            console.error('Error fetching jar sizes:', error);
            return null;
          }),
        ]);

        // Tote capacity per packaging type, mirroring the packing slip
        // generation in the backend (Fridge channel jar sizes)
        const toteSizes = {};
        (jarSizeResponse?.data?.getJarSize || [])
          .filter((record) => record.channel === 'Fridge')
          .forEach((record) => {
            toteSizes[record.jarSize] = record.maxJarPerTote;
          });

        // Process items data
        const items = itemsResponse.data.items;
        this.setState({ items: arrayToObject(items, 'id') });

        // Process opsLocations data
        const opsLocations = opsLocationsResponse.data.opsLocations.locations;
        const opsLocationsData = arrayToObject(opsLocations, 'id');

        const linehaulsUniqueValues = opsLocations
          .map((item) => item.linehaulFirstMile)
          .filter((value) => value !== null);
        const linehauls = [...new Set(linehaulsUniqueValues)];
        let formattedLinehaul = linehauls.map((linehaul) => ({
          value: linehaul,
        }));
        formattedLinehaul = formattedLinehaul.sort((a, b) =>
          a.value.localeCompare(b.value),
        );
        formattedLinehaul = formattedLinehaul.filter(
          (item) => item.value !== 'Does Not Exist',
        );

        const containerTypes = opsLocations.reduce((obj, location) => {
          const hasContainerType = location.containerType
            ? location.containerType
            : 'Box';
          return {
            ...obj,
            [location.id]: hasContainerType,
          };
        }, {});

        const isACostcoStore = opsLocations.reduce((obj, location) => {
          const isCostco = location?.opportunityName?.includes('Costco');
          return {
            ...obj,
            [location.id]: isCostco,
          };
        }, {});

        // Process allLocations data
        const allLocations = allLocationsResponse;
        const fridgeLocationIds = this.getFridgeLocationIds(allLocations);
        const fridgeLocationState = this.getFridgeLocationState(allLocations);

        // Set the state with all the processed data
        const curState = {
          items,
          isACostcoStore,
          fridgeLocationIds,
          fridgeLocationState,
          containerTypes,
          opsLocations: opsLocationsData,
          linehaulList: formattedLinehaul,
          toteSizes,
          itemsWithFoodInfo,
          isInitLoading: false,
        };
        this.setState(curState);
        curState.date = moment().format('YYYY-MM-DD');
        try {
          localStorage.setItem(
            'itemsAndLocationsCache',
            JSON.stringify(curState),
          );
        } catch (storageError) {
          // localStorage can be full (the localhost origin is shared by all
          // locally-run apps) — evict the stale cache and carry on, the
          // data is already in state
          console.error('Unable to cache items and locations:', storageError);
          localStorage.removeItem('itemsAndLocationsCache');
        }
      }
    } catch (error) {
      console.error(error);
      this.setState({ isInitLoading: false });
    }
  }

  async fetchAllPackingSlips(date) {
    const items = { data: { packingSlips: [] } };
    let nextToken = null;

    try {
      do {
        const response = await PaginatedPackingSlip(date, nextToken);
        if (response?.data?.paginatedPackingSlips?.packingSlips) {
          const packingSlips = response.data.paginatedPackingSlips.packingSlips;
          items.data.packingSlips.push(...packingSlips);
          nextToken = response.data.paginatedPackingSlips.nextToken;
        }
      } while (nextToken);
    } catch (error) {
      console.error(`Error fetching data for ${date}:`, error);
    }
    return items;
  }

  async downloadPackingSlips() {
    let packingSlips;
    // Based on user selection this will either download preview or actual packingslips
    try {
      if (this.state.previewSlips) {
        packingSlips = PackingSlipPreview(this.state.searchDate);
      } else {
        return await this.fetchAllPackingSlips(this.state.searchDate);
        // Comment out above and uncomment below to use mock data
        // packingSlips = returnedSlips;
      }
      return packingSlips;
    } catch (error) {
      console.error(error);
      this.setState({
        alertModal: {
          mode: true,
          text: 'Failed to download Packing Slips',
        },
      });
    }
  }

  getFridgeLocationIds(allLocations) {
    return allLocations.map((location) => location.id);
  }

  getFridgeLocationState(allLocations) {
    const locationAddresses = {};
    allLocations.map(
      (location) =>
        (locationAddresses[location.id] = this.getFridgeRegion(
          location.operationConfigs.address,
        )),
    );
    return locationAddresses;
  }

  cleanPackingSlips(packingSlips, items, opsLocations, fulfillmentPriority) {
    let pSlips;
    let palletData = {};

    if (packingSlips.hasOwnProperty('data')) {
      if (packingSlips.data.hasOwnProperty('packingSlips')) {
        pSlips = packingSlips.data.packingSlips;
      } else if (packingSlips.data.hasOwnProperty('packingSlipsPreview')) {
        const previewData = packingSlips.data.packingSlipsPreview;

        // Handle different data structures for backward compatibility
        if (Array.isArray(previewData)) {
          // Check if it's an array of packing slips (old format) or array of groups (new format)
          // New format has objects with 'pallet' or 'packingSlips' properties
          const isNewFormat =
            previewData.length > 0 &&
            previewData.some(
              (group) =>
                group.pallet !== undefined || group.packingSlips !== undefined,
            );

          if (isNewFormat) {
            // New format: Array of { pallet, packingSlips } groups
            pSlips = previewData.flatMap((group) => group.packingSlips || []);
            previewData.forEach((group) => {
              if (group.pallet) {
                // Map by uniqueId
                if (group.pallet.uniqueId) {
                  palletData[group.pallet.uniqueId] = group.pallet;
                }
                // Also map by packingSlipKey since packing slips reference this
                if (group.pallet.packingSlipKey) {
                  palletData[group.pallet.packingSlipKey] = group.pallet;
                }
              }
            });
          } else {
            // Old format: Array of packing slips directly
            pSlips = previewData;
          }
        } else if (previewData && typeof previewData === 'object') {
          // New format: Single object with { pallet, packingSlips }
          if (previewData.packingSlips) {
            pSlips = previewData.packingSlips;
            if (previewData.pallet) {
              // Map by uniqueId
              if (previewData.pallet.uniqueId) {
                palletData[previewData.pallet.uniqueId] = previewData.pallet;
              }
              // Also map by packingSlipKey since packing slips reference this
              if (previewData.pallet.packingSlipKey) {
                palletData[previewData.pallet.packingSlipKey] =
                  previewData.pallet;
              }
            }
          } else {
            // Fallback: treat as old format object with numeric keys
            pSlips = previewData;
          }
        }
      }
    }
    const result = [];
    for (const key in pSlips) {
      const tempData = pSlips[key].data;
      const tempDataNew = {};
      for (const d in tempData) {
        if (tempData[d].itemName === 'DTC_TIP' || tempData[d].value === 0) {
          continue;
        }

        tempDataNew[tempData[d].itemName] = {
          value: tempData[d].value,
          productionDate: tempData[d].productionDate,
          unitsPerPack: items[tempData[d].itemName]?.unitsPerPack,
        };
      }
      pSlips[key].data_ids = tempDataNew;

      const locationId = pSlips[key].location.split('&')[0].trim();

      // Add data from opsLocations
      const opsLocation = this.state.opsLocations[locationId];
      const locNames = ['CHI_QFS Retains', 'MENU_RD', 'CHI_DTC Buffers'];
      if (opsLocation) {
        pSlips[key].locationType = opsLocation.type;
        pSlips[key].sundriesMultiplier = opsLocation.sundriesMultiplier;
        pSlips[key].linehaulFirstMile = opsLocation.linehaulFirstMile;
        pSlips[key].linehaulMiddleMile = opsLocation.linehaulMiddleMile;
        // pSlips[key].market = opsLocation.market; TODO: Add `market` to packing slips when ID-4590 will be merged

        // Override linehaulFirstMile if route starts with "wi_"
        if (
          pSlips[key].linehaulFirstMile === 'IL-CHI' &&
          pSlips[key].driver?.startsWith('wi')
        ) {
          pSlips[key].linehaulFirstMile = 'WI-MKE';
        }
      }
      if (locNames.includes(locationId)) {
        pSlips[key].linehaulFirstMile = 'IL-CHI';
      }

      delete pSlips[key].data;

      // Add priority to each packing slip
      const matchingObject = fulfillmentPriority?.find((item) =>
        item.locations.includes(locationId),
      );

      if (matchingObject) {
        pSlips[key].fulfillmentPriority = matchingObject.priority || 0;
      } else {
        console.log(
          `Location ID "${locationId}" not found in the fulfillmentPriority array.`,
        );
      }

      // Add fulfillmentCenter to each packing slip
      pSlips[key].fulfillmentCenter =
        opsLocations[locationId]?.fulfillmentCenter || 'UNKNOWN';

      // Add onlineDate to each packing slip
      pSlips[key].onlineDate = opsLocations[locationId]?.onlineDate || false;

      result.push(pSlips[key]);
    }
    palletData = {};
    return { packingSlips: pSlips, palletData };
  }

  shouldDisplaySundry = (location, routeStop) => {
    // const isFridge = routeStop?.locationType === 'FRIDGE';
    // const isDetroit = location.startsWith('MI_');
    // return isFridge && isDetroit;
    return false;
  };

  sundryCount = (location, data, routeStop, sundryMultiplier) => {
    let spoonsCount = 0;
    let forksCount = 0;
    const cleanLocation = location.split('&')[0].trim();
    if (this.shouldDisplaySundry(cleanLocation, routeStop)) {
      Object.entries(data).forEach(([key, fields]) => {
        const item = this.state.items.find((item) => item.id === key);
        if (item?.sundryType === 'Fork') {
          forksCount += fields.value;
        }
        if (item?.sundryType === 'Spoon') {
          spoonsCount += fields.value;
        }
      });

      forksCount = Math.ceil(forksCount * sundryMultiplier);
      spoonsCount = Math.ceil(spoonsCount * sundryMultiplier);
      return {
        forks: forksCount,
        spoons: spoonsCount,
      };
    }
  };

  handleLinehaulFilterChange(value) {
    this.setState({
      linehaulFilter: value,
    });

    // If retailer filter is selected, fetch filtered opsLocations
    if (this.state.linehaulFilterType === 'retailer' && value) {
      this.filterRetailerOpsLocations(value.value);
    } else {
      // Clear retailer-filtered opsLocations when not filtering by retailer
      this.setState({
        retailerFilteredOpsLocations: {},
      });
    }
  }

  async getForecastData() {
    try {
      this.setState({
        isLoading: true,
      });
      const packingSlips = await this.downloadPackingSlips();
      if ('errors' in packingSlips) {
        const alertModal = this.state.alertModal;
        alertModal.mode = true;
        alertModal.text = packingSlips.errors[0].message;
        this.setState({ alertModal });
      } else {
        // The preview backend does not aggregate Home Delivery orders the
        // way slip generation does — approximate it on the frontend when
        // the Cold Chain retailer preview is requested.
        const isColdChainSelected =
          this.state.linehaulFilterType === 'retailer' &&
          this.state.linehaulFilter?.value === 'COLD_CHAIN';
        if (this.state.previewSlips && isColdChainSelected) {
          const ordersById = await fetchOrdersById(this.state.searchDate);
          packingSlips.data.packingSlipsPreview = [
            {
              pallet: null,
              packingSlips: aggregateColdChainPreviewSlips({
                previewSlips: flattenPreviewSlips(
                  packingSlips.data.packingSlipsPreview,
                ),
                ordersById,
                toteSizes: this.state.toteSizes,
                items: this.state.items,
              }),
            },
          ];
        }

        let packingSlipsLocationsIDs = [];
        if (this.state.previewSlips) {
          // Handle both old and new data structures for preview
          const previewData = packingSlips.data.packingSlipsPreview;
          let previewSlipsArray = [];

          if (Array.isArray(previewData)) {
            // Check if it's new format (array of groups) or old format (array of slips)
            if (previewData.length > 0 && previewData[0].packingSlips) {
              // New format: Array of { pallet, packingSlips } groups
              previewSlipsArray = previewData.flatMap(
                (group) => group.packingSlips || [],
              );
            } else {
              // Old format: Array of packing slips directly
              previewSlipsArray = previewData;
            }
          } else if (previewData && previewData.packingSlips) {
            // New format: Single object with { pallet, packingSlips }
            previewSlipsArray = previewData.packingSlips;
          }

          packingSlipsLocationsIDs = previewSlipsArray.map((item) => {
            return item.location.split('&')[0].trim();
          });
        } else {
          const getLocationIds = (item) => {
            return item.location.split('&')[0].trim();
          };
          packingSlipsLocationsIDs =
            packingSlips.data.packingSlips.map(getLocationIds);
        }

        const uniquePackingSlipsList = [...new Set(packingSlipsLocationsIDs)];
        const fulfillmentPriority = await GetFulfillmentPriority({
          locations: uniquePackingSlipsList,
        });

        const cleanedData = this.cleanPackingSlips(
          packingSlips,
          this.state.items,
          this.state.opsLocations,
          fulfillmentPriority.data.getFulfillmentPriority,
        );

        // For allocation page (non-preview), fetch pallets separately if not already available
        const palletData = cleanedData.palletData || {};
        if (!this.state.previewSlips && Object.keys(palletData).length === 0) {
          try {
            // const palletsResponse = await GetPallets({
            //   productionDate: this.state.searchDate,
            // });
            const palletsResponse = null;
            if (palletsResponse?.data?.getPallets) {
              palletsResponse.data.getPallets.forEach((pallet) => {
                if (pallet) {
                  // Map by uniqueId
                  if (pallet.uniqueId) {
                    palletData[pallet.uniqueId] = pallet;
                  }
                  // Also map by packingSlipKey since packing slips reference this
                  if (pallet.packingSlipKey) {
                    palletData[pallet.packingSlipKey] = pallet;
                  }
                }
              });
            }
          } catch (palletError) {
            console.error('Error fetching pallets:', palletError);
            // Continue without pallet data
          }
        }

        this.setState({
          isLoading: false,
          reportData: cleanedData.packingSlips,
          palletData,
          showPicker: false,
        });
      }
    } catch (e) {
      console.error(e);
      const alertModal = this.state.alertModal;
      alertModal.mode = true;
      alertModal.text =
        'Unable to load packing slips, Please check your internet and permissions';
      this.setState({ alertModal });
    }
  }

  handleDateChangeV2(value) {
    this.setState({
      searchDate: yyyymmdd(value, '-'),
      currentDate: value,
    });
  }

  showDatePicker() {
    this.setState({
      showPicker: !this.state.showPicker,
    });
  }

  getSortedData(data_array, summary) {
    // default multiplier for sundries, otherwise use the multiplier from the operations record
    const sundryMultiplier = 1.5;
    const groupedData = {};

    // Grouping by driver (route) and dropOffDate
    for (const i in data_array) {
      const location = data_array[i].location.split('&')[0].trim();

      // Marking items that are Costco stores
      if (
        this.state.isACostcoStore &&
        this.state.isACostcoStore[location] === true
      ) {
        data_array[i].costco = true;
      }

      // Assigning container type and updating summary data
      if (this.state.containerTypes) {
        data_array[i].containerType = this.state.containerTypes[location];
        if (!summary.data_ids[data_array[i].containerType]) {
          summary.data_ids[data_array[i].containerType] = { value: 0 };
        }
        summary.data_ids[data_array[i].containerType].value += 1;
      }

      // Grouping by driver and dropOffDate
      const driver = data_array[i].driver;
      const dropOffDate =
        data_array[i].dropOffDate == null ? 1 : data_array[i].dropOffDate;
      const groupKey = `${driver}-${dropOffDate}`;

      if (groupKey in groupedData) {
        groupedData[groupKey].push(data_array[i]);
      } else {
        groupedData[groupKey] = [data_array[i]];
      }
    }

    // Remove undefined container types from summary data
    delete summary.data_ids.undefined;
    groupedData.null = [summary];
    const sundryMap = {};
    // Sorting each group by various criteria in one sort function
    for (const j in groupedData) {
      // Sort by subPackingSlipIndex
      groupedData[j].sort((a, b) =>
        a.subPackingSlipIndex === b.subPackingSlipIndex
          ? 0
          : a.subPackingSlipIndex > b.subPackingSlipIndex
          ? 1
          : -1,
      );
      // Sort by combined driver-stop-location key
      groupedData[j].sort((a, b) =>
        `${a.driver} - ${a.stop}-${a.location.split('&')[0]}` >
        `${b.driver} - ${b.stop}-${b.location.split('&')[0]}`
          ? 1
          : -1,
      );
      groupedData[j].forEach((slip) => {
        if (!sundryMap[slip.location]) {
          const sundryData = this.sundryCount(
            slip.location,
            slip.data_ids,
            slip,
            slip.sundriesMultiplier || sundryMultiplier,
          );
          sundryMap[slip.location] = sundryData;
        } else {
          const sundryData = this.sundryCount(
            slip.location,
            slip.data_ids,
            slip,
            slip.sundriesMultiplier || sundryMultiplier,
          );
          sundryMap[slip.location].forks += sundryData.forks;
          sundryMap[slip.location].spoons += sundryData.spoons;
        }
      });
      groupedData[j].forEach((slip, i) => {
        if (sundryMap[slip.location]) {
          const temp = {
            ...slip,
            forks: sundryMap[slip.location].forks,
            spoons: sundryMap[slip.location].spoons,
          };
          if (slip.subPackingSlipIndex === slip.totalSubPackingSlips) {
            groupedData[j][i] = temp;
          }
        }
      });
    }
    // Sorting keys by fulfillmentPriority
    const sortedKeys = Object.keys(groupedData).sort((a, b) => {
      const aPriority = groupedData[a][0].fulfillmentPriority;
      const bPriority = groupedData[b][0].fulfillmentPriority;

      // First, sort by fulfillmentPriority
      if (aPriority !== bPriority) {
        return aPriority - bPriority; // Ascending order
      }

      // If priorities are the same, sort by date in descending order
      const aDate = groupedData[a][0].dropOffDate || '1970-01-01';
      const bDate = groupedData[b][0].dropOffDate || '1970-01-01';
      return new Date(bDate) - new Date(aDate); // Descending order
    });

    // Creating orderedGroupedData as a Map to preserve order
    let orderedGroupedData = new Map();
    const unrouted = new Map();
    const internals = new Map();
    sortedKeys.forEach((key) => {
      if (key.includes('Route data unavailable')) {
        unrouted.set(key, groupedData[key]);
      } else if (key.includes('Internal') || key.includes('NOT_NEEDED')) {
        internals.set(key, groupedData[key]);
      } else {
        orderedGroupedData.set(key, groupedData[key]);
      }
    });
    orderedGroupedData = new Map([
      ...internals,
      ...unrouted,
      ...orderedGroupedData,
    ]);
    return orderedGroupedData;
  }

  getSortedStopSummary(orderedGroupedData) {
    const stops = new Map();

    orderedGroupedData.forEach((orders, key) => {
      orders.forEach((order) => {
        if (order.clientCode === 'ThirdParty') {
          return;
        }
        const dropOffDate = order.dropOffDate == null ? '' : order.dropOffDate;
        const stopKey = order.location.split('&')[0] + order.date + dropOffDate;

        stops.set(
          stopKey,
          <tr key={stopKey}>
            <td>
              {order.driver} - {order.stop}
            </td>
            <td>{order.location.split('&')[0]}</td>
            <td>
              <div>
                {order.dropOffDate
                  ? moment(order.dropOffDate).format('dddd MMMM Do YYYY')
                  : 'Drop off date not specified'}
              </div>
            </td>
          </tr>,
        );
      });
    });

    return Array.from(stops.values());
  }

  filterFridgeOrders(route_stop) {
    const indexOfValue = this.state.fridgeLocationIds.findIndex(
      (i) => i === route_stop.addressForDelivery,
    );
    return (
      route_stop.type === 'ORDER' &&
      !route_stop.addressForDelivery.includes('SHOPIFY_') &&
      indexOfValue > -1
    );
  }

  filterCateringOrders(route_stop) {
    const indexOfValue = this.state.fridgeLocationIds.findIndex(
      (i) => i === route_stop.addressForDelivery,
    );
    return (
      (route_stop.type === 'ORDER' &&
        !route_stop.addressForDelivery.includes('SHOPIFY_') &&
        indexOfValue <= -1) ||
      (route_stop.type === 'ORDER' &&
        route_stop.addressForDelivery.includes('SHOPIFY_') &&
        indexOfValue <= -1 &&
        (route_stop.clientCode === 'Wholesale' ||
          route_stop.clientCode === 'Catering')) ||
      route_stop.type === 'INTERNAL_ORDER'
    );
  }

  // Helper method to check if a location is an ALDI location based on retailer data
  isAldiLocation(route_stop) {
    const locationId = route_stop.location.split('&')[0].trim();
    const locationData =
      this.state.retailerFilteredOpsLocations &&
      Object.keys(this.state.retailerFilteredOpsLocations).length > 0
        ? this.state.retailerFilteredOpsLocations
        : this.state.opsLocations;
    const opsLocation = locationData ? locationData[locationId] : null;

    return (
      opsLocation &&
      (opsLocation.retailer === 'ALDI' ||
        opsLocation.opportunityName === 'ALDI')
    );
  }

  filterLabelOrders(route_stop) {
    // If filtering by specific retailer
    if (
      this.state.linehaulFilterType === 'retailer' &&
      this.state.linehaulFilter
    ) {
      const selectedRetailer = this.state.linehaulFilter.value;

      // For ALDI retailer, use the accurate detection method
      if (selectedRetailer === 'ALDI') {
        return this.isAldiLocation(route_stop);
      }

      const locationId = route_stop.location.split('&')[0].trim();

      // Check if location matches the pattern for the selected retailer
      const patterns = RETAILER_LOCATION_PATTERNS[selectedRetailer];
      if (!patterns) {
        console.log(`No patterns found for retailer: ${selectedRetailer}`);
        return false;
      }

      const matchesPattern = patterns.some((pattern) =>
        route_stop.location.includes(pattern),
      );

      if (!matchesPattern) {
        return false;
      }

      // If location matches pattern, include it regardless of retailer data
      // This ensures we don't lose data due to missing retailer metadata
      const retailerFilteredOpsLocations =
        this.state.retailerFilteredOpsLocations;
      const opsLocation = retailerFilteredOpsLocations[locationId];

      if (opsLocation) {
        console.log(
          `Location ${locationId} passes both retailer field and pattern filtering for ${selectedRetailer}`,
        );
      } else {
        console.log(
          `Location ${locationId} matches pattern but has no retailer data - including anyway`,
        );
      }

      return true;
    }

    return Object.values(RETAILER_LOCATION_PATTERNS)
      .flat()
      .some((pattern) => route_stop.location.includes(pattern));
  }

  getFridgeRegion(fridgeAddress) {
    let address = fridgeAddress;
    const statesCodes = Object.keys(US_STATES);
    const statesCustomCodes = Object.keys(US_STATES_CUSTOM_CODES);
    // remove all commas
    address = address.replace(/,/g, '');
    // remove unnecessary spaces in between
    address = address.replace(/\s+/g, ' ');
    // split address string into words
    const partsOfAddress = address.trim().split(' ');
    for (let i = 0; i < partsOfAddress.length; i++) {
      if (statesCodes.includes(partsOfAddress[i])) {
        return partsOfAddress[i];
      }
      if (statesCustomCodes.includes(partsOfAddress[i])) {
        const correctStateCode = US_STATES_CUSTOM_CODES[partsOfAddress[i]];
        return US_STATES[correctStateCode];
      }
    }
    return 'UNKNOWN_REGION';
  }

  getOrderRegion(location) {
    const currentLocation = location.split('&')[0];
    const prefix = currentLocation.split('_')[0];
    const listOfFridgeLocationState = this.state.fridgeLocationState;

    if (prefix in US_STATES) {
      return prefix;
    }

    if (prefix in US_STATES_CUSTOM_CODES) {
      return US_STATES_CUSTOM_CODES[prefix];
    }

    if (currentLocation in listOfFridgeLocationState) {
      return listOfFridgeLocationState[currentLocation];
    }

    return 'UNKNOWN_REGION';
  }

  render() {
    const {
      reportData,
      searchDate,
      previewSlips,
      packingSlipPreviewType,
      packingSlipType,
      linehaulFilter,
      linehaulFilterType,
      palletData,
    } = this.state;

    const currentlyDisplaying = `Currently Displaying: ${searchDate}`;

    let packingSlipText = '';
    let filtersApplied = '';

    if (previewSlips) {
      packingSlipText = packingSlipPreviewType.toUpperCase().replace(/-/g, ' ');
    } else {
      packingSlipText = packingSlipType.toUpperCase().replace(/-/g, ' ');
    }

    const linehaulText =
      linehaulFilterType !== 'all'
        ? linehaulFilterType === 'retailer'
          ? `Retailer: ${linehaulFilter?.value || 'None'}`
          : Array.isArray(linehaulFilter)
          ? linehaulFilter.map((item) => item.value).join(', ')
          : 'None'
        : 'All LINEHAUL';

    filtersApplied = `${packingSlipText} & ${linehaulText}`;

    let keys = [];
    let data_array = {};
    const sums = {
      location: 'Summary',
      data_ids: {},
    };

    const LAYOUT = generateLayout(this.state.items);

    const isColdChainSelected =
      linehaulFilterType === 'retailer' &&
      linehaulFilter?.value === 'COLD_CHAIN';

    if (Array.isArray(reportData)) {
      const renderData = reportData.filter((route_stop) => {
        const isOrderType = route_stop.type === 'ORDER';
        const isInternalOrderType = route_stop.type === 'INTERNAL_ORDER';
        const isAllocationType = route_stop.type === 'ALLOCATION';
        const isCostco = route_stop.location.includes('COSTCO_');
        const isLabelOrder = this.filterLabelOrders(route_stop);

        // Linehaul filtering logic with added check for linehaulFilter array
        const linehaulFirstMile = route_stop.linehaulFirstMile;
        const linehaulFilterValues = Array.isArray(this.state.linehaulFilter)
          ? this.state.linehaulFilter.map((filter) => filter.value)
          : [];

        // Skip linehaul filtering if linehaulFilterType is "all"
        const passesLinehaulFilter =
          linehaulFilterType === 'all' ||
          linehaulFilterType === 'retailer' ||
          (linehaulFilterType === 'select' &&
            linehaulFirstMile &&
            linehaulFilterValues.includes(linehaulFirstMile)) ||
          (route_stop.location === 'INTERNAL' &&
            linehaulFilterValues.includes('IL-CHI'));

        if (!passesLinehaulFilter) return false;

        // Apply preview and packingSlipType filters
        if (previewSlips) {
          if (packingSlipPreviewType === 'all-orders') {
            return isOrderType || isInternalOrderType;
          }
          if (packingSlipPreviewType === 'fridge-orders') {
            return this.filterFridgeOrders(route_stop);
          }
          if (packingSlipPreviewType === 'non-fridge-orders') {
            return this.filterCateringOrders(route_stop);
          }
          if (packingSlipPreviewType === 'label-orders') {
            return this.filterLabelOrders(route_stop);
          }
        } else if (packingSlipType === 'all') {
          return !isCostco && !isLabelOrder;
        } else if (packingSlipType === 'order') {
          return (
            (isOrderType || isInternalOrderType) && !isLabelOrder && !isCostco
          );
        } else if (packingSlipType === 'allocation') {
          return isAllocationType && !isLabelOrder && !isCostco;
        } else if (packingSlipType === 'label-orders') {
          return this.filterLabelOrders(route_stop);
        }

        return false;
      });

      keys = Object.keys(renderData);
      data_array = renderData;
    }

    keys.forEach((key) => {
      const skus = Object.keys(data_array[key].data_ids);

      // Iterate over the skus
      skus.forEach((sku) => {
        const valueToAdd = parseInt(
          data_array[key].data_ids[sku]?.value || 0,
          10,
        );

        if (valueToAdd === 0) {
          return;
        }

        // Initialize sums.data_ids[sku] if it doesn't exist
        if (!sums.data_ids[sku]) {
          sums.data_ids[sku] = { value: 0 };
        }

        // Add valueToAdd to sums.data_ids[sku].value
        sums.data_ids[sku].value += valueToAdd;
      });
    });

    let stops = [];
    let rows = [];
    if (Object.keys(data_array).length > 0) {
      const orderedGroupedData = this.getSortedData(data_array, sums);
      stops = this.getSortedStopSummary(orderedGroupedData);

      // Separate ALDI slips from regular slips for special handling
      const aldiSlips = [];
      const regularSlips = [];

      orderedGroupedData.forEach((routeStops) => {
        routeStops.forEach((route_stop, index) => {
          if (route_stop.clientCode !== 'ThirdParty') {
            const isAldi = this.isAldiLocation(route_stop);
            if (isAldi) {
              aldiSlips.push({ route_stop, index });
            } else {
              regularSlips.push({ route_stop, index });
            }
          }
        });
      });
      // Group all regular (non-ALDI, non-ThirdParty) slips by pallet
      const slipsByPallet = {}; // palletUniqueId -> [route_stop, ...]
      const nopalletSlips = []; // slips without a pallet

      orderedGroupedData.forEach((routeStops) => {
        routeStops.forEach((route_stop) => {
          if (route_stop.clientCode === 'ThirdParty') return;
          if (this.isAldiLocation(route_stop)) return;

          // Home delivery totes are handed to the Cold Chain 3PL —
          // pallet slips are not printed for them
          const palletId = isColdChainSelected
            ? null
            : route_stop.palletUniqueId;
          if (palletId && palletData[palletId]) {
            if (!slipsByPallet[palletId]) {
              slipsByPallet[palletId] = [];
            }
            slipsByPallet[palletId].push(route_stop);
          } else {
            nopalletSlips.push(route_stop);
          }
        });
      });

      // Track rendered pallet IDs to avoid duplicates
      const renderedPalletIds = new Set();
      // Count unique displayed pallets (by packingSlipKey, not UUID duplicates);
      // pallets without packing slips on this page are not rendered
      const uniquePallets = new Set(
        Object.keys(slipsByPallet).map(
          (palletId) => palletData[palletId]?.packingSlipKey || palletId,
        ),
      );
      const totalPallets = uniquePallets.size;

      // Render pallet groups in pallet order (linehaul, then sequence):
      // PalletSlip followed by its packing slips sorted by driver/stop
      const orderedPalletEntries = Object.entries(slipsByPallet).sort(
        ([palletIdA], [palletIdB]) =>
          comparePalletsForDisplay(
            palletData[palletIdA],
            palletData[palletIdB],
          ),
      );
      orderedPalletEntries.forEach(([palletId, slips]) => {
        const palletElements = [];
        const pallet = palletData[palletId];

        // Render PalletSlip header
        renderedPalletIds.add(palletId);
        if (pallet.uniqueId) {
          renderedPalletIds.add(pallet.uniqueId);
        }
        palletElements.push(
          <PalletSlip
            key={`pallet-${palletId}`}
            pallet={pallet}
            palletIndex={renderedPalletIds.size - 1}
            totalPallets={totalPallets}
          />,
        );

        // Sort slips within pallet by driver, then stop
        slips.sort((a, b) => {
          const aKey = `${a.driver}-${a.stop}-${a.location}`;
          const bKey = `${b.driver}-${b.stop}-${b.location}`;
          return aKey > bKey ? 1 : -1;
        });

        slips.forEach((route_stop, index) => {
          palletElements.push(
            <RouteStop
              key={`${route_stop.uniqueId || route_stop.location}-${
                route_stop.date
              }-${index}`}
              routeStop={route_stop}
              layout={LAYOUT}
              items={this.state.items}
              fridgeLocationState={this.state.fridgeLocationState}
              orderRegion={this.getOrderRegion(route_stop.location)}
              isAldiLocation={this.isAldiLocation(route_stop)}
              isColdChainSelected={isColdChainSelected}
              toteSizes={this.state.toteSizes}
            />,
          );
        });

        rows.push(palletElements);
      });

      // Render slips without a matching pallet
      if (nopalletSlips.length > 0) {
        const noPalletElements = [];
        nopalletSlips.forEach((route_stop, index) => {
          noPalletElements.push(
            <RouteStop
              key={`no-pallet-${route_stop.uniqueId || route_stop.location}-${
                route_stop.date
              }-${index}`}
              routeStop={route_stop}
              layout={LAYOUT}
              items={this.state.items}
              fridgeLocationState={this.state.fridgeLocationState}
              orderRegion={this.getOrderRegion(route_stop.location)}
              isAldiLocation={this.isAldiLocation(route_stop)}
              isColdChainSelected={isColdChainSelected}
              toteSizes={this.state.toteSizes}
            />,
          );
        });
        rows.push(noPalletElements);
      }

      // Render ALDI slips in groups of 15 using PrintGridContainer
      if (aldiSlips.length > 0) {
        const aldiGroups = [];
        for (let i = 0; i < aldiSlips.length; i += 15) {
          aldiGroups.push(aldiSlips.slice(i, i + 15));
        }

        aldiGroups.forEach((group, groupIndex) => {
          const aldiGroupContent = group.map(({ route_stop }, slipIndex) => (
            <RouteStop
              key={`aldi-${route_stop.uniqueId || route_stop.location}-${
                route_stop.date
              }-${groupIndex}-${slipIndex}`}
              routeStop={route_stop}
              layout={LAYOUT}
              items={this.state.items}
              fridgeLocationState={this.state.fridgeLocationState}
              orderRegion={this.getOrderRegion(route_stop.location)}
              isAldiLocation={this.isAldiLocation(route_stop)}
              isGrouped
              groupIndex={slipIndex}
            />
          ));

          // Pad the group to exactly 15 slips if needed
          while (aldiGroupContent.length < 15) {
            aldiGroupContent.push(
              <div
                key={`aldi-placeholder-${groupIndex}-${aldiGroupContent.length}`}
              />,
            );
          }

          rows.push(
            <div
              key={`aldi-wrap-${groupIndex}`}
              style={{ marginLeft: '-44px', padding: 0 }}
            >
              <PrintGridContainer
                className="aldi-group-container"
                key={`aldi-group-${groupIndex}`}
              >
                {aldiGroupContent}
              </PrintGridContainer>
            </div>,
          );
        });
      }
    } else {
      const today = moment().startOf('day');
      const currentDateMoment = moment(this.state.currentDate).startOf('day');

      rows = (
        <div>
          <Alert bsStyle="danger">
            <h3>No Packing Slips found for the selected date and filters</h3>
          </Alert>
          <br />
          {currentDateMoment.isSameOrAfter(today) && (
            <Alert bsStyle="info">
              <h3>
                Packing slips are not created until 6pm on the day of. If you
                would like to view a preview of PackingSlips created from
                orders, please view them on the{' '}
                <a href="https://facility.farmerfridge.com/reports/allocation/preview">
                  Packing Slip Preview Page
                </a>
                .
              </h3>
            </Alert>
          )}
        </div>
      );
    }

    return (
      <div>
        <h1>{this.state.title} Packing Slips</h1>

        {this.state.previewSlips && (
          <Alert bsStyle="info">
            <strong>This page is for viewing only.</strong> To print packing
            slips, please use the{' '}
            <a href="/reports/allocation">Generated Packing Slips</a> page.
          </Alert>
        )}

        {!this.state.showPicker && (
          <div>
            <h2>{currentlyDisplaying}</h2>
            <h3>Filters Applied: {filtersApplied}</h3>
            <LoaderButton
              data-test="Loader-Button"
              block
              bsStyle="primary"
              bsSize="large"
              onClick={this.showDatePicker}
              type="submit"
              isLoading={Object.keys(this.state.containerTypes).length === 0}
              text="Click to choose Another Date"
              loadingText={`Loading Data for: ${this.state.searchDate}`}
            />
          </div>
        )}
        {this.state.showPicker && (
          <Grid style={{ minHeight: '80vh' }}>
            <Row className="text-center" style={{ marginBottom: '24px' }}>
              <div className="inputLabel">Production Date</div>
              <DatePicker
                data-test="Date-Picker"
                onChange={this.handleDateChangeV2}
                value={this.state.currentDate}
              />
            </Row>

            {!this.state.previewSlips ? (
              <>
                <div className="inputWrapper">
                  <ToggleButtonGroup
                    type="radio"
                    name="options"
                    value={this.state.packingSlipType}
                    onChange={(e) => {
                      this.setState({
                        packingSlipType: e,
                        linehaulFilter: null,
                        linehaulFilterType: 'all',
                        retailerFilteredOpsLocations: {},
                      });
                    }}
                  >
                    <ToggleButton value="all">All Packing Slips</ToggleButton>
                    <ToggleButton value="order">Orders</ToggleButton>
                    <ToggleButton value="allocation">Allocation</ToggleButton>
                    <ToggleButton value="label-orders">
                      Label Orders
                    </ToggleButton>
                  </ToggleButtonGroup>
                </div>
              </>
            ) : (
              <Row style={{ margin: '0px 0px 24px 0px' }}>
                <ToggleButtonGroup
                  type="radio"
                  name="options"
                  value={this.state.packingSlipPreviewType}
                  onChange={(e) => {
                    this.setState({
                      packingSlipPreviewType: e,
                      linehaulFilter: null,
                      linehaulFilterType: 'all',
                      retailerFilteredOpsLocations: {},
                    });
                  }}
                >
                  <ToggleButton value="all-orders">All Orders</ToggleButton>
                  <ToggleButton value="fridge-orders">
                    Fridge Orders
                  </ToggleButton>
                  <ToggleButton value="non-fridge-orders">
                    Non-Fridge Orders
                  </ToggleButton>
                  <ToggleButton value="label-orders">Label Orders</ToggleButton>
                </ToggleButtonGroup>
              </Row>
            )}
            <div className="inputWrapper">
              <div>
                <ToggleButtonGroup
                  type="radio"
                  name="options"
                  value={this.state.linehaulFilterType}
                  onChange={(e) => {
                    this.setState({
                      linehaulFilterType: e,
                      linehaulFilter: null,
                      retailerFilteredOpsLocations: {},
                    });
                  }}
                >
                  <ToggleButton value="all">All Linehaul</ToggleButton>
                  <ToggleButton value="select">Select Linehaul</ToggleButton>
                  {(this.state.previewSlips
                    ? this.state.packingSlipPreviewType === 'label-orders'
                    : this.state.packingSlipType === 'label-orders') && (
                    <ToggleButton value="retailer">Retailer</ToggleButton>
                  )}
                </ToggleButtonGroup>
              </div>
              {this.state.linehaulFilterType !== 'all' && (
                <>
                  <Select
                    options={
                      this.state.linehaulFilterType === 'retailer'
                        ? this.state.retailerOptions
                        : this.state.linehaulList
                    }
                    getOptionLabel={(option) => option.value}
                    isMulti={this.state.linehaulFilterType === 'select'}
                    closeMenuOnSelect={
                      this.state.linehaulFilterType === 'retailer'
                    }
                    hideSelectedOptions={false}
                    onChange={this.handleLinehaulFilterChange}
                    isLoading={this.state.isLoading || this.state.isInitLoading}
                    isDisabled={
                      this.state.isLoading || this.state.isInitLoading
                    }
                    value={this.state.linehaulFilter}
                    maxMenuHeight={400}
                    styles={{
                      control: (baseStyles) => ({
                        ...baseStyles,
                        borderRadius: '0px',
                        border: '1px solid gray',
                        width: '380px',
                      }),
                    }}
                  />
                </>
              )}
            </div>
            <p />
            <Row className="text-center">
              {!this.state.isInitLoading ? (
                <Button
                  bsStyle="primary"
                  bsSize="large"
                  onClick={this.getForecastData}
                  data-testid="Search Button"
                  disabled={
                    this.state.isLoading ||
                    (this.state.linehaulFilterType === 'select' &&
                      !this.state.linehaulFilter?.length) ||
                    (this.state.linehaulFilterType === 'retailer' &&
                      !this.state.linehaulFilter)
                  }
                >
                  {this.state.isLoading ? 'Loading...' : 'Search'}
                </Button>
              ) : (
                <>
                  <Loading />
                  <span>Initial Data Fetching...</span>
                </>
              )}
            </Row>
          </Grid>
        )}
        <hr />
        <div style={{ pageBreakBefore: 'always', margin: 0, padding: 0 }} />
        <div style={{ margin: 0, padding: 0 }} />
        <div key="data" style={{ fontSize: 'large' }}>
          {!this.state.isLoading &&
            !this.state.showPicker &&
            Object.keys(this.state.containerTypes).length > 0 && (
              <Table data-test="stops-table">
                <tbody>{stops}</tbody>
              </Table>
            )}
          <div style={{ pageBreakBefore: 'always', margin: 0, padding: 0 }} />
          {!this.state.isLoading &&
            !this.state.showPicker &&
            Object.keys(this.state.containerTypes).length > 0 &&
            rows}
        </div>
      </div>
    );
  }
}
